import { useState, useEffect, Fragment, createRef } from "react";
import moment from "moment";
import theme from "../../theme/theme";
import alertsListData from "mockdata/alertsListData";
import Tabs from "elements/Tabs";
import SearchIcon from "../../assets/searchIcon.svg";
import CloseIcon from "../../assets/closeIcon.svg";
import SearchBox from "../../elements/SearchBox";
import useTranslation from "../../localization/translations";
import AlertsListItem from "components/AlertsListItem";
import { formattedCardListData } from "../../utils/utils";
import useStyles from "./styles";

const AlertsList: React.FC<any> = (props) => {
  const {
    alertsData,
    consolidatedData,
    selectedMarker,
    setSelectedMarker,
    setSelectedNotification,
    selectedNotification,
    tabIndex,
    setTabIndex,
    setNotificationTimeStamp,
  } = props;

  const [appTheme, setAppTheme] = useState(theme?.defaultTheme);
  const {
    alertsRightPanel,
    dashboarListTitle,
    listTitleName,
    listSearch,
    dashboardListSection,
    searchClass,
    noResultStyle,
    customNotificationTabs,
  } = useStyles(appTheme);

  const [selectedTheme, setSelectedTheme] = useState(
    JSON.parse(localStorage.getItem("theme")!)
  );

  const { dashboardListName, search, noResult } = useTranslation();

  const [selectedRefId, setSelectedRefId] = useState("");
  const [searchOpen, setSearchOpen] = useState<any>(false);

  const [eventDataArray, setEventDataArray] = useState<any>();
  const [alertDataArray, setAlertDataArray] = useState<any>();
  const [operationsDataArray, setOperationsDataArray] = useState<any>();

  const [alertsDataList, setAlertsDataList] = useState(
    formattedCardListData(tabIndex, consolidatedData)
  );
  const [searchValue, setSearchValue] = useState<any>(alertsDataList);
  const handleTabs = (index: number) => {
    setTabIndex(index);
    setSearchOpen(false);
    // setSelectedNotification("");
  };

  useEffect(() => {
    setAlertsDataList(formattedCardListData(tabIndex, consolidatedData));
    setSearchValue(formattedCardListData(tabIndex, consolidatedData));
  }, [tabIndex]);

  useEffect(() => {
    setAlertsDataList(formattedCardListData(tabIndex, consolidatedData));
    setSearchValue(formattedCardListData(tabIndex, consolidatedData));
  }, []);

  useEffect(() => {
    switch (selectedTheme) {
      case "red":
        setAppTheme(theme?.redTheme);
        break;
      case "green":
        setAppTheme(theme?.greenTheme);
        break;
      case "yellow":
        setAppTheme(theme?.yellowTheme);
        break;
      case "default":
        setAppTheme(theme?.defaultTheme);
        break;
      default:
        setAppTheme(theme?.defaultTheme);
        break;
    }
  }, [selectedTheme]);

  const tabsList = [
    {
      name: "Events",
      val: 0,
      count: alertsData?.events?.length,
    },
    {
      name: "Alerts",
      val: 1,
      count: alertsData?.alerts?.length,
    },
    {
      name: "Operations",
      val: 2,
      count: alertsData?.operations?.length,
    },
  ];

  const handleSearch = (searchValue: any) => {
    let searchResult = alertsDataList?.filter((value: any) => {
      return (
        value?.title
          ?.toLowerCase()
          .includes(searchValue?.toString()?.toLowerCase()) ||
        value?.area
          ?.toLowerCase()
          .includes(searchValue?.toString()?.toLowerCase()) ||
        value?.name
          ?.toLowerCase()
          .includes(searchValue?.toString()?.toLowerCase())
      );
    });
    setSearchValue(searchResult);
    setSearchOpen(true);
    setSelectedNotification(-1);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
    setSearchValue(alertsDataList);
    setSelectedNotification(-1);
  };

  const refs =
    searchValue && searchValue.length > 0
      ? searchValue.reduce((acc: any, value: any) => {
          acc[value.id] = createRef<any>();
          return acc;
        }, {})
      : "";

  // refID - Marker Ref ID,  selectedRefId - list Ref ID

  useEffect(() => {
    if ((selectedMarker || selectedRefId) && refs) {
      setTimeout(() => {
        refs[
          selectedMarker ? selectedMarker : selectedRefId
        ]?.current?.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }, 300);
    }
  }, [refs, selectedRefId, selectedMarker, tabIndex]);

  const handleExpandListItem = (index: number, id: any, dateTime: any) => {
    setSelectedNotification(selectedNotification === id ? -1 : id);
    setSelectedRefId(id);
    setNotificationTimeStamp(dateTime);
  };

  return (
    <div className={alertsRightPanel}>
      <div className={dashboarListTitle}>
        <div className={listTitleName}>
          {!searchOpen ? (
            "Alerts"
          ) : (
            <SearchBox
              searchInput={searchClass}
              placeHolder={search}
              handleSearch={handleSearch}
              searchIsOpen={true}
              fontColor={appTheme?.palette?.dashboardList?.darkGrey3}
            />
          )}
        </div>
        <div className={listSearch}>
          <img
            src={searchOpen ? CloseIcon : SearchIcon}
            alt="search"
            onClick={searchOpen ? handleSearchClose : handleSearch}
          />
        </div>
      </div>
      <div>
        <Tabs
          initialIndex={tabIndex}
          tabsList={tabsList}
          handleTabs={handleTabs}
          dashboardNotificationClassName={customNotificationTabs}
        />
      </div>
      <div className={dashboardListSection}>
        {searchValue && searchValue.length > 0
          ? searchValue?.map((item: any, index: number) => {
              return (
                <AlertsListItem
                  refs={refs}
                  data={item}
                  key={index}
                  handleExpandListItem={handleExpandListItem}
                  selectedNotification={selectedNotification}
                  // handleViewDialogue={handleViewDialogue}
                  notificationTimeStamp={""}
                />
              );
            })
          : "No Result Found"}
      </div>
    </div>
  );
};
export default AlertsList;
